export const getTransferAmount = ({ transferAmount }) => transferAmount.amount;
